import axios from 'axios';
import config from '../../config/configureSettings';
import { constructServiceURL } from '../../core/modules/common/tools/URLTools';

export const doSearch = (searchString) => axios.get(constructServiceURL({
  endpoint: 'doSearch',
  stub: config.useStubbedEndpoints,
  params: { searchString },
}));
